module.exports = __webpack_public_path__ + "static/media/img-destaque-internas.fa12057f.jpg";